import React from 'react'
import SignupForm from '../../components/signup/SignupForm'
import '../../styles/loginPage/login.css';

const SignupPage = () => {
  return (
    <>
        <div className="signup-container">
        <SignupForm/>
        </div>
        
    </>
  )
}

export default SignupPage